"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./CheckboxCard.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ValueColor = {
  positive: 'text.positive',
  negative: 'text.negative',
  default: 'text.1'
};
const CheckboxCard = /*#__PURE__*/React.forwardRef(({
  meta,
  id,
  title,
  description,
  onChange,
  exchangeDetails,
  tag,
  checked = false,
  ...otherProps
}, ref) => {
  var _ValueColor$exchangeD, _ValueColor$exchangeD2;

  const [active, setActive] = React.useState(checked);

  const handleChange = e => {
    setActive(!active);

    if (onChange) {
      onChange(e);
    }
  };

  return (0, _pragma.createFelaElement)(_.Card, {
    width: "full",
    as: "label",
    htmlFor: id,
    css: css.wrapper,
    cssProps: {
      active
    }
  }, (0, _pragma.createFelaElement)(_.View, _extends({
    css: css.container,
    flexDirection: "column",
    justifyContent: "center",
    gap: "small",
    ref: ref
  }, otherProps), (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "row",
    gap: "small",
    alignItems: "center",
    justifyContent: "space-between"
  }, (0, _pragma.createFelaElement)(_.View, {
    alignItems: "center",
    gap: "small"
  }, (0, _pragma.createFelaElement)(_.Text, {
    children: title,
    variant: "body",
    transform: "capitalize",
    weight: "bold"
  }), meta && (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    transform: "capitalize"
  }, meta)), (0, _pragma.createFelaElement)(_.View, {
    gap: "small",
    alignItems: "center"
  }, tag && (0, _pragma.createFelaElement)(_.Tag, tag), (0, _pragma.createFelaElement)(_.Checkbox, {
    id: id,
    checked: active,
    onChange: handleChange
  }))), (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    gap: "small"
  }, description && (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: "text.1"
  }, description), exchangeDetails && (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column"
  }, (0, _pragma.createFelaElement)(_.View, {
    justifyContent: "space-between",
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.Text, {
    transform: "uppercase"
  }, exchangeDetails.scripName), (0, _pragma.createFelaElement)(_.Text, {
    variant: "body"
  }, (0, _pragma.createFelaElement)(_.Text, null, "\u20B9"), exchangeDetails.value)), (0, _pragma.createFelaElement)(_.View, {
    justifyContent: "space-between",
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta"
  }, exchangeDetails.exchange), (0, _pragma.createFelaElement)(_.View, {
    gap: "xxsmall"
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: (_ValueColor$exchangeD = ValueColor[exchangeDetails.valueChange]) !== null && _ValueColor$exchangeD !== void 0 ? _ValueColor$exchangeD : 'default'
  }, exchangeDetails.valueChange === 'positive' && '+', exchangeDetails.valueChange === 'negative' && '-', exchangeDetails.value), (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: (_ValueColor$exchangeD2 = ValueColor[exchangeDetails.valueChange]) !== null && _ValueColor$exchangeD2 !== void 0 ? _ValueColor$exchangeD2 : 'default'
  }, (0, _pragma.createFelaElement)("span", null, "("), exchangeDetails.percentValue, (0, _pragma.createFelaElement)("span", null, ")"))))))));
});
CheckboxCard.displayName = 'CheckboxCard';
var _default = CheckboxCard;
exports.default = _default;
//# sourceMappingURL=CheckboxCard.js.map